module.exports = __webpack_public_path__ + "img/gr.b54e0c7b.svg";